import React, { FC } from 'react';

import { Box, HStack } from '@chakra-ui/react';
import { FiAlertTriangle } from 'react-icons/fi';

import { StackedCell } from 'components/DataDisplay';
import { CustomTooltip } from 'components/DataDisplay/Tooltip/CustomTooltip';

import { GrantorsLine } from './GrantorsLine';
import { DataAccessRow } from './utils';

interface OwnAccessCellProps {
  row: DataAccessRow;
}

/**
 * The levels granted on the resource itself, and who grants them. A database
 * or schema with no grant of its own is listed only because of something
 * inside it, which the warning explains.
 */
export const OwnAccessCell: FC<OwnAccessCellProps> = ({ row }) => {
  // The "via" line opens the full list of roles (GrantorsLine), so its
  // tooltip, which only repeated the cut-off text, is off.
  if (row.ownLevels.length)
    return (
      <StackedCell
        upper={row.ownLevels.join(', ')}
        lower={<GrantorsLine grantors={row.ownGrantors} />}
        showLowerTooltip={false}
      />
    );
  return (
    <StackedCell
      upper={
        <HStack spacing={1} color="gray.400">
          <Box>None</Box>
          <CustomTooltip
            label={`No grant on this ${row.kind}. Grants inside it need USAGE on the ${row.kind} to be usable.`}
          >
            <Box color="medium">
              <FiAlertTriangle />
            </Box>
          </CustomTooltip>
        </HStack>
      }
      lower={`No grant on this ${row.kind}`}
      showUpperTooltip={false}
    />
  );
};
